import Cookies from 'js-cookie';
import type { StressAssessmentRole } from '../../../../apps/client/src/types/model/stressAssessment';

export const COOKIE_NAME = 'stress_assessment_role';

const isValidStressAssessmentRole = (value: unknown): value is StressAssessmentRole =>
  value === 'practitioner' || value === 'implementer';

export const getStressAssessmentRole = (): StressAssessmentRole | undefined => {
  const role = Cookies.get(COOKIE_NAME);
  return isValidStressAssessmentRole(role) ? role : undefined;
};

export const setStressAssessmentRole = (stressAssessmentRole: StressAssessmentRole) =>
  Cookies.set(COOKIE_NAME, stressAssessmentRole);
export const removeStressAssessmentRole = () => Cookies.remove(COOKIE_NAME);
